import deburr from "lodash/deburr";

export const normalizeDescription = (input: string): string => {
  return deburr(input.normalize().replace(/\s+/g, " ").trim().toLowerCase());
};

export const areDescriptionsEqual = (
  a: string | null | undefined,
  b: string | null | undefined,
): boolean => {
  if (a === null || a === undefined) {
    return false;
  }
  if (b === null || b === undefined) {
    return false;
  }

  return normalizeDescription(a) === normalizeDescription(b);
};

export const createKeyFromDescription = (description?: string | null): string => {
  if (!description) {
    return "";
  }
  return normalizeDescription(description).toUpperCase().replace(/\s+/g, "_");
};
